
<div>
  <b-aspect aspect="16:9" class="w-100 h-100">
    <div class="image-aspect-ratio d-flex align-items-center">
      <b-img-lazy
        class="mh-100 mw-100 mx-auto"
        :src="jel_getFichierSrc(content.image)"
        :alt="content.altImage"
      />
    </div>
  </b-aspect>
  <div class="pt-2" v-html="content.titre" />
</div>
